// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1aAZ3","content":"styles_content__12Mef","checkbox":"styles_checkbox__21mS8","checkboxLabel":"styles_checkboxLabel__21E1C"};